import React from "react"
import { ShareQrcodeTest } from "./tests/ShareQrcodeTest"

export const Testing = () => {
    return <>
        <ShareQrcodeTest/>
    </>
}